import dictionary from './copy.json';

export interface NavLink {
  label: string;
  href: string;
}

export type CopySetName = keyof typeof dictionary;

export const copySets = dictionary;
export const activeCopySet: CopySetName = 'manufacturing'; /* manufacturing -- data-verbiage -- loremIpsum */
export const copy = dictionary[activeCopySet];

export const siteName = copy.siteName;
export const breadcrumb: NavLink[] = copy.breadcrumb;
export const hero = copy.hero;
